import { PackageInspectorShow } from "@/resources/packages/PackageInspectorShow";

/**
 * Principle detail — the shared Inspector grammar over a
 * `package_type='principle'` record (overview, body, package links, audit).
 * Compile is the primary action.
 */
export function PrincipleShow() {
  return (
    <PackageInspectorShow
      resource="principles"
      dataResource="packages"
      expectType="principle"
      label="Principle"
      subtitle="A governing principle that constrains frames, contours, and skills."
    />
  );
}

export default PrincipleShow;
